import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { CheckoutPageProvider } from "../../contexts";

import {
  ConfirmEmail,
  // GetStarted, // Account Type Selection
  ForgotPassword,
  HostedPaymentLinks,
  IFramePaymentRedirectHandler,
  NotFoundPages,
  RedirectToSignUpWithInvitationCode,
  ResetPassword,
  SignIn,
  SignUp,
  SignUpWithInvitationCode,
} from "../../pages";

export const AuthLayout = () => {
  return (
    <Routes>
      {/* <Route path="*" element={<GetStarted />} /> */}
      <Route path="*" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/account/confirm-email" element={<ConfirmEmail />} />

      <Route path="/signup-with-code" element={<SignUpWithInvitationCode />} />
      <Route
        path="/invitations/accept-team-invitation"
        element={<RedirectToSignUpWithInvitationCode />}
      />

      <Route
        path="/hosted-payment-links/*"
        element={
          <CheckoutPageProvider>
            <HostedPaymentLinks isPreviewMode={false} />
          </CheckoutPageProvider>
        }
      />

      <Route
        path="/iframe-payment-redirect-handler/*"
        element={<IFramePaymentRedirectHandler />}
      />

      {/* NOT FOUND PAGES */}
      <Route path="/page-not-found/*" element={<NotFoundPages />} />

      <Route
        path="/hosted-link-expired/*"
        element={
          <NotFoundPages
            pageType="payment-link"
            message="This payment link has either expired or does not exist"
          />
        }
      />
    </Routes>
  );
};
